<template>
  <b-modal
    id="modal-preview-photo"
    ref="modalPreviewPhoto"
    size="md"
    centered
    :title="`Modal ${$t('rfidAndFacerecognition.photo.viewPhoto')}`"
  >
    <b-card class="mc-card mc-card__setting mc-card__setting--preview-photo">
      <div class="d-flex justify-content-center align-items-center">
        <img
          :src="employee?.photograph"
          style="
            width: 100%;
            height: auto;
            object-fit: cover;
            border-radius: 8px;
            max-height: 400px;
          "
          :alt="`Photo Preview of ${employee?.fullname}`"
        />
      </div>
    </b-card>
    <template #modal-footer="{ cancel }">
      <b-row class="mc-modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="mc-modal__filter-footer-btn mt-0">
          <McButton
            :data-me="`master-fr-btn-close-modal-preview-${employee?.userId}`"
            variant="outline-primary"
            class="me-2"
            :text="$t('global.action.close')"
            @click="cancel()"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

export default {
  name: 'ModalPreviewPhoto',
  components: {
    McButton,
  },
  mixins: [Helper],
  data() {
    return {
      fileExt: null,
      employee: null,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },
  methods: {
    show(employee) {
      this.employee = employee
      this.$bvModal.show('modal-preview-photo')
    },
    hide() {
      this.$bvModal.hide('modal-preview-photo')
    },
  },
}
</script>

<style lang="scss" scoped></style>
